import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllutrationFoldersEmptyStateMobile(props) {
  return (
    <svg
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 67.2V96h96V0H67.2v67.2H0z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 28.8V60h28.8V28.8H60V0H0v28.8z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IllutrationFoldersEmptyStateMobile;
